export default __webpack_public_path__ + "static/media/half-circle.543829e2.svg";